/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Defines the enum of DefaultActionTypes and corresponding interfaces.
 * Is used as the "glue" to connect [[SplitData]] and [[DefaultActionHandlers]].
 */

import { FancyAction } from '../base/FancyAction';

//technically only need to bother creating interfaces for action types that have additional properties
export type CombinedDefaultActions<Model = any> =
	| FancyAction<Model>
	| AddItemAction<Model>
	| ChangeViewAction<Model>
	| AbortViewAction<Model>;

export interface AddItemAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.addItem;
	renderType: string;
	idOverride?: string;
	persistImmediately?: boolean;
}

export interface RemoveItemAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.addItem;
	renderType: string;
}

export interface ChangeViewAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.changeView;
	renderType: string;
}
export interface AbortViewAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.abortView;
	renderType: string;
}
export interface PersistDataAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.persistData;
	renderType: string;
}

export interface LocalUpdateAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.localUpdate;
	renderType?: string;
}

export interface SelectionDataLoadedAction<Model = any> extends FancyAction<Model> {
	type: DefaultActionTypes.selectionDataLoaded;
	loaded: boolean;
}

export enum DefaultActionTypes {
	addItem = 'add_item',
	removeItem = 'remove_item',
	localUpdate = 'local_update',
	changeView = 'change_view',
	abortView = 'abort_view',
	cameraChanged = 'camera_changed',
	//changeToPrimaryView = "change_to_primary_view", //remove this if it's not used
	persistData = 'persist_data',
	selectionDataLoaded = 'selection_data_loaded',
}
